<template>
  <div class="row" style="margin-top: 10px">
    <div class="col-6">
      <div class="row">
        <div class="col">
          <label for="formFileSm" class="form-label">Tipo do Documento</label>
          <input type="text" class="form-control form-input-component" v-model="formAnexoDocumento.nomeDocumento" />
        </div>
        <div class="col">
          <label for="formFileSm" class="form-label">Importar Arquivo</label>
          <input class="form-control form-control-sm" id="formFileSm" type="file" name="file" ref="files" multiple />
        </div>
        <div class="col-1">
          <a-tooltip title="Salvar anexo" placement="right">
            <i class="fa-solid fa-upload upload-archive" style="cursor: pointer" @click="uploadFile"></i>
          </a-tooltip>
        </div>
      </div>
    </div>
    <div class="col">
      <a-table :dataSource="anexoDocumentoAcompanhamentoList" :columns="columns">
        <template #nomeDocumento="{ record }">
          <span>{{ record.anexoDocumentoAcompanhamento.nomeDocumento }}</span>
        </template>
        <template #dataInsercao="{ record }">
          <span>{{ formatDate(record.dataInsercao) }}</span>
        </template>
        <template #anexo="{ record }">
          <span>{{ record.anexoDocumentoAcompanhamento.nomeArquivo }}</span>
        </template>
        <template #action="{ record }">
          <i class="far fa-file-alt" style="margin-right: 5px; cursor: pointer" @click="baixarArquivo(record)"></i>
          <a @click="removeDataArchive(record)"><i class="fas fa-trash icon-trash"></i></a>
        </template>
        <template>
          <a-pagination :total="500" />
        </template>
      </a-table>
    </div>

    <Dialog
      header="Motivo Deletar Anexo"
      v-model:visible="showDeleteAnexo"
      style="
         {
          width: 90vw;
          backgroundcolor: #dcdeff;
        }
      "
      id="deleteAnxo"
    >
      <div class="row">
        <div class="col">
          <label class="form-label">Motivo Exclusão</label>
          <input type="text" class="form-control form-input-component" v-model="motivoExclusao" />
        </div>
        <div class="row float-end" style="margin-top: 10px; margin-left: 2px">
          <button type="button" class="btn btn-primary" @click="excluirAnexo()" style="margin-right: 10px">Excluir</button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { downloadDocumentFileWs, isArquivoValido, sendDocumentFileWs } from '@/utils/filews';
import { openNotification, typesNotification } from '@/utils/notifications';
import { getByIdRegistroAtendimento } from '@/components/service/registroAtendimentoService';
import { createAnexoAcompanhamentoMedico, exclusaoLogica, getAnexoAcompRegistroAtendimentoId } from '@/components/service/anexo-acompanhamento-medico';
import { formatarData } from '@/utils/servicos-utils';

export default {
  name: 'AnexoDocumentoAcompanhamento',
  data() {
    return {
      anexoDocumentoAcompanhamentoList: [],
      registroAtendimento: null,
      showDeleteAnexo: false,
      anxoDocAcomp: null,
      motivoExclusao: null,
      idRegistroAtendimento: null,
      form: {
        paciente: null,
        profissional: null,
        anexoDocumentoAcompanhamento: null,
        dataInsercao: null,
      },
      formAnexoDocumento: {
        idAnexoFileWs: null,
        nomeDocumento: null,
        nomeArquivo: null,
      },
      columns: [
        {
          title: 'Documento',
          dataIndex: 'nomeDocumento',
          key: 'nomeDocumento',
          slots: { customRender: 'nomeDocumento' },
        },
        {
          title: 'Data Inserção',
          dataIndex: 'dataInsercao',
          key: 'dataInsercao',
          slots: { customRender: 'dataInsercao' },
        },
        {
          title: 'Anexo',
          dataIndex: 'anexo',
          key: 'anexo',
          slots: { customRender: 'anexo' },
        },
        {
          title: 'Ação',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  async created() {
    this.idRegistroAtendimento = this.$route.query.id;
    await getByIdRegistroAtendimento(this.idRegistroAtendimento).then(async (r) => {
      this.registroAtendimento = r.data;
      await this.getAnexos();
    });
  },
  methods: {
    async uploadFile() {
      if (this.formAnexoDocumento.nomeDocumento && this.$refs.files.files[0]) {
        let validarTamanho = isArquivoValido('', '', this.$refs.files.files[0].size, true);
        if (validarTamanho.tamanho) {
          await sendDocumentFileWs(this.$refs.files.files[0], 'TOKEN', 'ssp').then(async (r) => {
            const obj = {
              idAnexoFileWs: r.data.id,
              nomeDocumento: this.formAnexoDocumento.nomeDocumento,
              nomeArquivo: r.data.nomeOriginal,
            };
            await this.saveAnexo(obj);
            openNotification(typesNotification.success, 'Arquivo enviado com sucesso');
          });
        } else {
          openNotification(typesNotification.error, 'Tamanho de arquivo não suportado.');
        }
      } else {
        openNotification(typesNotification.warning, 'Selecione o nome do documento e o arquivo do documento.');
      }
    },
    async saveAnexo(obj) {
      let anexoAcompanhamentoMedico = {};
      anexoAcompanhamentoMedico.anexoDocumentoAcompanhamento = obj;
      anexoAcompanhamentoMedico.registroAtendimento = this.registroAtendimento;
      await createAnexoAcompanhamentoMedico(anexoAcompanhamentoMedico).then(async () => {
        await this.getAnexos();
        this.formAnexoDocumento = {};
        this.$refs.files = '';
      });
    },
    async getAnexos() {
      await getAnexoAcompRegistroAtendimentoId(this.idRegistroAtendimento).then((r) => {
        this.anexoDocumentoAcompanhamentoList = r.data;
      });
    },
    async baixarArquivo(document) {
      await downloadDocumentFileWs(document.anexoDocumentoAcompanhamento.idAnexoFileWs, document.anexoDocumentoAcompanhamento.nomeArquivo);
    },
    formatDate(data) {
      return formatarData(new Date(data), 'DD/MM/YYYY HH:mm');
    },
    removeDataArchive(obj) {
      this.anxoDocAcomp = obj;
      this.showDeleteAnexo = true;
    },
    async excluirAnexo() {
      if (this.motivoExclusao && this.motivoExclusao.length > 0) {
        this.anxoDocAcomp.motivoExclusao = this.motivoExclusao;
        await exclusaoLogica(this.anxoDocAcomp).then(async () => {
          await this.getAnexos();
          this.motivoExclusao = '';
          this.showDeleteAnexo = false;
        });
      } else {
        openNotification(typesNotification.warning, 'Descreva a justificativa da remoção.');
      }
    },
  },
};
</script>

<style scoped>
.upload-archive {
  font-size: 25px;
  margin-top: 30px;
}
</style>
